import Skeleton from '@mui/material/Skeleton';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import AccountRamRedirect from '../AccountRamRedirect/AccountRamRedirect';
import AuthActions from '../AuthActions/AuthActions';
import type { ClassesProp } from '../LoggedIn/LoggedIn';
import LoggedIn from '../LoggedIn/LoggedIn';

interface Props {
  classes?: {
    loggedIn?: ClassesProp;
  };
}

const LoginMenu: React.FC<Props> = ({ classes }) => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const isServerAuthenticated = useSelector(select.session.isServerAuthenticated);
  const divertRAMToPoker = useFeature(FeatureFlag.DivertRAMToPoker);

  switch (true) {
    case isServerAuthenticated:
      return (
        <ThemeProvider theme={createTheme({ palette: { mode: 'dark' } })}>
          <Skeleton animation="wave">
            <AuthActions />
          </Skeleton>
        </ThemeProvider>
      );
    case divertRAMToPoker:
      return <AccountRamRedirect />;
    case isAuthenticated:
      return <LoggedIn classes={classes?.loggedIn} />;
    default:
      return <AuthActions />;
  }
};

export default LoginMenu;
